import { type CarrierDef } from '../common.js'
import { password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password] as const

export type ckcoCredType = (typeof credentialTypes)[number]
export const ckco: CarrierDef<ckcoCredType> = {
  name: 'CaseStack',
  scac: 'ckco',
  credentialTypes,
  legacyCredMap: [...userPassMap],
  engineLayers: ['rating'],
}
